import "./style.css";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../Assets/Images/Lendriva_logo.jpg";
import righticon from "../../Assets/Images/right-icon.png";
import storage from "@utils/storage";

export const Passwordsuccessfullyreset = () => {
  const Id = storage.getUserType();
  const role = Id?.userType;
  const roleType = role;

  const [, setSelectedUserType] = useState<
    "borrower" | "lender"
  >("borrower");

  useEffect(() => {
    const loginPage = document.querySelector(".onboarding-page");

    if (loginPage) {
      loginPage.classList.remove("theme-borrower", "theme-lender");
      loginPage.classList.add(`theme-${roleType}`);
    }
  }, [roleType]);
  useEffect(() => {
    if (roleType === "borrower" || roleType === "lender") {
      setSelectedUserType(roleType);
    }
  }, [roleType]);

  return (
    <>
    <div>
      <div className="onboarding-page">
        <div className="reset-pw p-0 my-3">
          <div className="password-success-blk upper-div login-blk align-items-center d-flex justify-content-end mb-3 p-0">
            <div className="close-icon cursor-pointer text-end">
              <Link to="/auth/login">
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7502 9.84501L13.0577 12.5L15.7502 15.155C15.8252 15.2252 15.8849 15.3099 15.9257 15.4041C15.9666 15.4983 15.9876 15.5999 15.9876 15.7025C15.9876 15.8052 15.9666 15.9067 15.9257 16.0009C15.8849 16.0951 15.8252 16.1799 15.7502 16.25C15.6801 16.3195 15.597 16.3745 15.5056 16.4118C15.4143 16.4492 15.3164 16.4681 15.2177 16.4675C15.021 16.4667 14.8324 16.3886 14.6927 16.25L12.0002 13.5575L9.34522 16.25C9.20552 16.3886 9.01697 16.4667 8.82022 16.4675C8.72151 16.4681 8.62367 16.4492 8.53229 16.4118C8.44091 16.3745 8.3578 16.3195 8.28772 16.25C8.14803 16.1095 8.06962 15.9194 8.06962 15.7213C8.06962 15.5231 8.14803 15.333 8.28772 15.1925L10.9427 12.5L8.28772 9.84501C8.16485 9.70153 8.10064 9.51697 8.10794 9.32822C8.11523 9.13946 8.19348 8.9604 8.32705 8.82683C8.46062 8.69326 8.63967 8.61501 8.82843 8.60772C9.01719 8.60043 9.20174 8.66464 9.34522 8.78751L12.0002 11.4425L14.6552 8.78751C14.7247 8.71561 14.8076 8.65809 14.8992 8.61824C14.9909 8.57838 15.0895 8.55697 15.1895 8.55523C15.2894 8.55349 15.3887 8.57145 15.4817 8.60809C15.5747 8.64472 15.6596 8.69932 15.7315 8.76876C15.8034 8.83819 15.8609 8.92111 15.9007 9.01278C15.9406 9.10444 15.962 9.20306 15.9637 9.303C15.9655 9.40294 15.9475 9.50224 15.9109 9.59524C15.8742 9.68824 15.8197 9.77311 15.7502 9.84501ZM19.4252 19.925C17.9567 21.3934 16.0858 22.3933 14.049 22.7983C12.0123 23.2034 9.90112 22.9954 7.98255 22.2006C6.06399 21.4059 4.42418 20.0601 3.27047 18.3334C2.11676 16.6067 1.50098 14.5767 1.50098 12.5C1.50098 10.4233 2.11676 8.39332 3.27047 6.66663C4.42418 4.93994 6.06399 3.59412 7.98255 2.79937C9.90112 2.00462 12.0123 1.79662 14.049 2.20168C16.0858 2.60674 17.9567 3.60666 19.4252 5.075C20.4003 6.05003 21.1739 7.20759 21.7016 8.48158C22.2293 9.75557 22.501 11.121 22.501 12.5C22.501 13.879 22.2293 15.2444 21.7016 16.5184C21.1739 17.7924 20.4003 18.95 19.4252 19.925ZM18.3677 6.1325C17.1078 4.87696 15.5041 4.02289 13.7591 3.67816C12.0142 3.33342 10.2062 3.51348 8.56345 4.19558C6.92073 4.87769 5.51697 6.03126 4.52942 7.51062C3.54187 8.98999 3.01482 10.7288 3.01482 12.5075C3.01482 14.2862 3.54187 16.025 4.52942 17.5044C5.51697 18.9838 6.92073 20.1373 8.56345 20.8194C10.2062 21.5015 12.0142 21.6816 13.7591 21.3369C15.5041 20.9921 17.1078 20.1381 18.3677 18.8825C19.2068 18.0464 19.8725 17.0528 20.3267 15.9589C20.781 14.8649 21.0148 13.692 21.0148 12.5075C21.0148 11.323 20.781 10.1501 20.3267 9.05614C19.8725 7.96217 19.2068 6.96864 18.3677 6.1325Z"
                    fill="black"
                  />
                </svg>
              </Link>
            </div>
          </div>
          <div className="pw-success-block lower-div">
            <div className="row m-0">
              <div className="col text-center logo-fit">
                <img src={logo} alt="" className="img-fluid" />
              </div>
            </div>
            <div className="row m-0">
              <div className="col">
                <div className="pw-success-box">
                  <div className="right-icon">
                    <img src={righticon} alt="" className="img-fluid" />
                  </div>
                  <p className="mt-4 pw-successtext">
                    Password successfully reset! You can now log in with your
                    new password.
                  </p>
                  <Link to="/auth/login">
                    <button
                      type="submit"
                      className="btn btn-lender signin w-100 border-radius"
                    >
                      Login
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default Passwordsuccessfullyreset;
